import { CmpTable, SectionTitle } from "../../shared";
import SubComponent from "./SubComponent";
import { GET_ALL_VEEVA_CONFIG } from "./query";

const VeevaConfigList = () => {
    const columns = [
        {
            id: "countryName",
            accessorKey: "country",
            header: "Country",
        },
        {
            accessorKey: "identityType",
            header: "Identity Type",
        },
        {
            accessorKey: "veevaInstanceType",
            header: "Instance Type",
        },
        {
            accessorKey: "aemCountryNode",
            header: "Country Node",
        },
        {
            accessorKey: "aemLanguageNode",
            header: "Language Node",
        },
    ];

    const renderSubComponent = (data) => <SubComponent data={data.row.original} />;

    return (
        <>
            <SectionTitle
                title="Veeva Configurations"
                buttonUrl="/global-config/abbvie-id/veeva-config/create"
                backUrl="/global-config/abbvie-id"
            />

            <CmpTable
                QUERY={GET_ALL_VEEVA_CONFIG}
                headers={columns}
                renderSubComponent={renderSubComponent}
                dataPath="allVeevaEnvironmentConfigurations"
            />
        </>
    );
};

export default VeevaConfigList;
